<footer class="footer">
  <div class="container">
    @if (phone || email) {
      <div class="row">
        <div class="col-12">
          @if (!hideSocialMedia()) {
            <app-social-media-footer></app-social-media-footer>
          }
          <hr>
          @if (showExtendedContactUs()) {
            <app-contact-us-footer></app-contact-us-footer>
          } @else {
            <div class="col-12 col-lg-5 col-xl-4">
              <p class="contact-support__title">{{ 'app-footer.contact' | translate }}</p>
              <div class="contact-support__container">
                <address>
                  @if (phone) {
                    <p class="contact-support__item">
                      <span class="icon-phone"></span>
                      <a href="tel:{{ phone }}">{{ phone | phoneNumber: phoneNumberFormat || '4|3|2|2' : delimiter || ' ' : prefix || '' }}</a>
                    </p>
                  }
                  @if (email) {
                    <p class="contact-support__item">
                      <span class="icon-email"></span>
                      <a href="mailto:{{ email }}">{{ email }}</a>
                    </p>
                  }
                </address>
              </div>
            </div>
            @if (isInStore) {
              <div class="col-12">
                <div class="contact-support__container">
                  <p class="contact-support__item">
                    {{ 'app-footer.contact-to-grievances-officer-desc1' | translate }}
                    <a class="contact-support__item-link" href="mailto:{{ emailGrievancesOfficer }}">
                      {{ 'app-footer.contact-to-grievances-officer' | translate }}</a>{{ 'app-footer.contact-to-grievances-officer-desc2' | translate }}
                  </p>
                </div>
              </div>
            }
          }
        </div>
      </div>
    }
    <div class="row">
      <div class="col-12">
        <hr>
        <ul class="legal-links">
          <li class="legal-links__item" [attr.data-test]="'footer-legal-link-address'">
            <address>{{ getAddress() }}</address>
          </li>
          @if (taxId) {
            <li class="legal-links__item" [attr.data-test]="'footer-legal-link-taxId'">
              {{ taxId }}
            </li>
          }
          @for (link of links; track link.title) {
            <li class="legal-links__item" [attr.data-test]="'footer-legal-link-' + link.title">
              @if (link.nodeType === 'link') {
                <a [routerLink]="link.url" [target]="'_self'" class="legal-links__link">{{ link.title }}</a>
              } @else {
                <a [href]="link.url" [target]="'_blank'" class="legal-links__link">{{ link.title }}</a>
              }
            </li>
          }
        </ul>
      </div>
    </div>
  </div>
</footer>
